import BoldText from '@/components/BoldText';
import BaseImage from '@/components/Icons/BaseImage';
import { Button } from '@shopify/polaris';

interface IProps {
  imgSource: string;
  title: string;
  onAction?: () => void;
  titleActionBtn?: string;
  variant?: 'primary' | 'plain' | 'tertiary' | 'monochromePlain';
  disabled?: boolean;
}

export default function EmptyContent({ imgSource, title, onAction, titleActionBtn, variant, disabled }: IProps) {
  return (
    <div className="d-flex flex-column">
      <div style={{ textAlign: 'center' }}>
        <BaseImage src={imgSource} alt="empty" style={{ height: '200px', width: '200px' }} />
      </div>
      <div style={{ textAlign: 'center' }}>
        <BoldText>{title}</BoldText>
      </div>
      {onAction && titleActionBtn ? (
        <div className="mt-16" style={{ textAlign: 'center' }}>
          <Button variant={variant} onClick={onAction} disabled={disabled}>
            {titleActionBtn}
          </Button>
        </div>
      ) : null}
    </div>
  );
}
